import { render, staticRenderFns } from "./liveConfig.vue?vue&type=template&id=43107470&scoped=true"
import script from "./liveConfig.vue?vue&type=script&lang=ts"
export * from "./liveConfig.vue?vue&type=script&lang=ts"
import style0 from "./liveConfig.vue?vue&type=style&index=0&id=43107470&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43107470",
  null
  
)

export default component.exports